function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Location from '../geom/Location';
import Position from './Position';
import PointLocation from '../algorithm/PointLocation';
import TopologyException from '../geom/TopologyException';
import Orientation from '../algorithm/Orientation';
import Label from './Label';
import ArrayList from '../../../../java/util/ArrayList';
import Assert from '../util/Assert';
var EdgeRing = /*#__PURE__*/function () {
  function EdgeRing() {
    _classCallCheck(this, EdgeRing);
    EdgeRing.constructor_.apply(this, arguments);
  }
  return _createClass(EdgeRing, [{
    key: "computeRing",
    value: function computeRing() {
      if (this._ring !== null) return null;
      var coord = new Array(this._pts.size()).fill(null);
      for (var i = 0; i < this._pts.size(); i++) {
        coord[i] = this._pts.get(i);
      }
      this._ring = this._geometryFactory.createLinearRing(coord);
      this._isHole = Orientation.isCCW(this._ring.getCoordinates());
    }
  }, {
    key: "isIsolated",
    value: function isIsolated() {
      return this._label.getGeometryCount() === 1;
    }
  }, {
    key: "computePoints",
    value: function computePoints(start) {
      this._startDe = start;
      var de = start;
      var isFirstEdge = true;
      do {
        if (de === null) throw new TopologyException('Found null DirectedEdge');
        if (de.getEdgeRing() === this) throw new TopologyException('Directed Edge visited twice during ring-building at ' + de.getCoordinate());
        this._edges.add(de);
        var label = de.getLabel();
        Assert.isTrue(label.isArea());
        this.mergeLabel(label);
        this.addPoints(de.getEdge(), de.isForward(), isFirstEdge);
        isFirstEdge = false;
        this.setEdgeRing(de, this);
        de = this.getNext(de);
      } while (de !== this._startDe);
    }
  }, {
    key: "getLinearRing",
    value: function getLinearRing() {
      return this._ring;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate(i) {
      return this._pts.get(i);
    }
  }, {
    key: "computeMaxNodeDegree",
    value: function computeMaxNodeDegree() {
      this._maxNodeDegree = 0;
      var de = this._startDe;
      do {
        var node = de.getNode();
        var degree = node.getEdges().getOutgoingDegree(this);
        if (degree > this._maxNodeDegree) this._maxNodeDegree = degree;
        de = this.getNext(de);
      } while (de !== this._startDe);
      this._maxNodeDegree *= 2;
    }
  }, {
    key: "addPoints",
    value: function addPoints(edge, isForward, isFirstEdge) {
      var edgePts = edge.getCoordinates();
      if (isForward) {
        var startIndex = 1;
        if (isFirstEdge) startIndex = 0;
        for (var i = startIndex; i < edgePts.length; i++) {
          this._pts.add(edgePts[i]);
        }
      } else {
        var _startIndex = edgePts.length - 2;
        if (isFirstEdge) _startIndex = edgePts.length - 1;
        for (var _i = _startIndex; _i >= 0; _i--) {
          this._pts.add(edgePts[_i]);
        }
      }
    }
  }, {
    key: "isHole",
    value: function isHole() {
      return this._isHole;
    }
  }, {
    key: "setInResult",
    value: function setInResult() {
      var de = this._startDe;
      do {
        de.getEdge().setInResult(true);
        de = de.getNext();
      } while (de !== this._startDe);
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(p) {
      var shell = this.getLinearRing();
      var env = shell.getEnvelopeInternal();
      if (!env.contains(p)) return false;
      if (!PointLocation.isInRing(p, shell.getCoordinates())) return false;
      for (var i = this._holes.iterator(); i.hasNext();) {
        var hole = i.next();
        if (hole.containsPoint(p)) return false;
      }
      return true;
    }
  }, {
    key: "addHole",
    value: function addHole(ring) {
      this._holes.add(ring);
    }
  }, {
    key: "isShell",
    value: function isShell() {
      return this._shell === null;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this._label;
    }
  }, {
    key: "getEdges",
    value: function getEdges() {
      return this._edges;
    }
  }, {
    key: "getMaxNodeDegree",
    value: function getMaxNodeDegree() {
      if (this._maxNodeDegree < 0) this.computeMaxNodeDegree();
      return this._maxNodeDegree;
    }
  }, {
    key: "getShell",
    value: function getShell() {
      return this._shell;
    }
  }, {
    key: "mergeLabel",
    value: function mergeLabel() {
      if (arguments.length === 1) {
        var deLabel = arguments[0];
        this.mergeLabel(deLabel, 0);
        this.mergeLabel(deLabel, 1);
      } else if (arguments.length === 2) {
        var _deLabel = arguments[0];
        var geomIndex = arguments[1];
        var loc = _deLabel.getLocation(geomIndex, Position.RIGHT);
        if (loc === Location.NONE) return null;
        if (this._label.getLocation(geomIndex) === Location.NONE) {
          this._label.setLocation(geomIndex, loc);
          return null;
        }
      }
    }
  }, {
    key: "setShell",
    value: function setShell(shell) {
      this._shell = shell;
      if (shell !== null) shell.addHole(this);
    }
  }, {
    key: "toPolygon",
    value: function toPolygon(geometryFactory) {
      var holeLR = new Array(this._holes.size()).fill(null);
      for (var i = 0; i < this._holes.size(); i++) {
        holeLR[i] = this._holes.get(i).getLinearRing();
      }
      var poly = geometryFactory.createPolygon(this.getLinearRing(), holeLR);
      return poly;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeRing;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { EdgeRing as default };
EdgeRing.constructor_ = function () {
  this._startDe = null;
  this._maxNodeDegree = -1;
  this._edges = new ArrayList();
  this._pts = new ArrayList();
  this._label = new Label(Location.NONE);
  this._ring = null;
  this._isHole = null;
  this._shell = null;
  this._holes = new ArrayList();
  this._geometryFactory = null;
  if (arguments.length === 0) {} else if (arguments.length === 2) {
    var start = arguments[0];
    var geometryFactory = arguments[1];
    this._geometryFactory = geometryFactory;
    this.computePoints(start);
    this.computeRing();
  }
};